import axios from 'axios';
import Qs from 'qs';

import {
  SNACKBAR_TYPES,
  API_RESPONSE_STATUS,
  HTTP_STATUS,
} from '@/utils/constants';
import { snackbar } from './snackbar';

const paramsSerializer = (params) => Qs.stringify(params, { arrayFormat: 'brackets' });

export default {
  install(Vue, { router, store }) {
    if (!router || !store) {
      throw new Error('Please initialize plugin with a Vuex store and Vue router.');
    }

    const OLD_VERSION = 0;
    const DEFAULT_API_VERSION = 1;
    const service = axios.create({
      paramsSerializer,
      timeout: 30000,
    });

    async function api({
      method,
      url,
      data,
      version = DEFAULT_API_VERSION,
      ...attrs
    }) {
      const finalToken = localStorage.getItem('_t');
      const apiKey = localStorage.getItem('_k');
      const options = {
        ...attrs,
        baseURL: process.env.VUE_APP_API_URI,
        headers: {
          'Content-Type': 'application/json',
        },
        method,
        url: version === OLD_VERSION ? `v1/client/backend/${url}` : `api/v${version}/${url}`,
      };
      const methods = [
        HTTP_STATUS.DELETE,
        HTTP_STATUS.PATCH,
        HTTP_STATUS.POST,
        HTTP_STATUS.PUT,
      ];
      const methodToLower = method.toLowerCase();
      if (methodToLower === HTTP_STATUS.GET) {
        options.params = { ...data };
      } else if (methods.includes(methodToLower)) {
        options.data = data;
      }

      if (apiKey) {
        options.headers['x-api-key'] = apiKey;
      }
      if (finalToken) {
        options.headers.Authorization = `Bearer ${finalToken}`;
      }

      try {
        const res = await service(options);
        const { data: datum = {}, status } = res;

        if (datum instanceof Blob) {
          /* Resolving promise anyway if we are downloading file */
          return Promise.resolve(datum);
        }

        if (+status === 200 && version > OLD_VERSION) {
          return Promise.resolve(datum);
        }

        if (datum?.status === API_RESPONSE_STATUS.NORMAL) {
          return Promise.resolve(datum);
        }

        return Promise.reject(datum);
      } catch (error) {
        const { response: { data: errorData, status } = {} } = error;
        if (status === API_RESPONSE_STATUS.NOT_AUTH) {
          snackbar({
            type: SNACKBAR_TYPES.ERROR,
            msg: '登入已逾期，正在導向登入頁⋯',
          });
          store.dispatch('user/USER_LOGOUT');
          if (router.currentRoute.path !== '/login') {
            router.push('/login');
          }
        }
        return Promise.reject(errorData || error);
      }
    }

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$api = () => ({
      del: (payload) => api({ method: HTTP_STATUS.DELETE, ...payload }),
      get: (payload) => api({ method: HTTP_STATUS.GET, ...payload }),
      patch: (payload) => api({ method: HTTP_STATUS.PATCH, ...payload }),
      post: (payload) => api({ method: HTTP_STATUS.POST, ...payload }),
      put: (payload) => api({ method: HTTP_STATUS.PUT, ...payload }),
    });
  },
};
